import React, { useState, useEffect } from 'react';
import './AboutImageCarousel.css';

const AboutImageCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const media = [
    '/videoabout.mp4',
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % media.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + media.length) % media.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-play
  useEffect(() => {
    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="about-carousel-container">
      <div className="about-carousel">
        <div className="about-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {media.map((video, index) => (
            <div key={index} className="about-carousel-slide">
              <video 
                src={video} 
                className="about-carousel-media"
                controls
                autoPlay
                muted
              />
            </div>
          ))}
        </div>
        
        <div className="about-carousel-indicators">
          {media.map((_, index) => (
            <button
              key={index}
              className={`about-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutImageCarousel;
